import React, {Component} from 'react'
import '../../../../styles/Wyszukiwarka.css'
import {Button} from "react-bootstrap";
import * as acc from "accounting";
import BiletyMiesieczneService from "./BiletyMiesieczneService";
import HistoriaKarty from "./szczegolyKartyComponents/HistoriaKarty";
import DoladowanieKarty from "./szczegolyKartyComponents/DoladowanieKarty";

export default class PokazSzczegolyKarty extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            doladuj: false,
            loading: true
        }
    }

    checkWazna(item) {
        if (item.ostWaznyOd === null && item.ostWaznyDo === null) {
            return 'Brak danych'
        } else {
            return item.ostWaznyOd.substr(0, 10) + ' - ' + item.ostWaznyDo.substr(0, 10)
        }
    }

    checkCena(item) {
        if (item.ostCena === null) {
            return 'Brak danych'
        } else {
            return acc.formatMoney(item.ostCena, {
                symbol: "zł",
                format: "%v %s"
            })
        }
    }

    checkKierunek(kierunek) {
        switch (kierunek) {
            case 1:
                return 'w jedną stronę';
            case 2:
                return 'w obie strony'
        }
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        BiletyMiesieczneService.getBiletyMiesieczne(this.props.item.idKa)
            .then(function (response) {
                let res = response.data;
                this.setState({data: res, loading: false})
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    render() {

        let item = this.props.item;

        return <div>

            <b>Szczegóły karty:</b>
            <div className="wynik biletyMiesieczne" style={{marginBottom: 20}}>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-4">
                                <div>Numer
                                    karty: <b>{item.nrKarty}</b></div>
                            </div>
                            <div className="col-8">
                                <div>Ważna: <b>{this.checkWazna(item)}</b></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-4 miejscowosciOdDoMies">
                                {item.nazMiOd} - {item.nazMiDo}
                            </div>
                            <div className="col-sm-4 waznyMies">
                                <div>
                                    Status: {item.status === 'NOWA' ?
                                    <span style={{color: '#17a2b8'}}>{item.status}</span> : <span>
                                        {item.status === 'ZWROCONA' ?
                                            <span style={{color: '#dc3545'}}>{item.status}</span> :
                                            <span style={{color: '#28a745'}}>{item.status}</span>}
                                    </span>}
                                </div>
                            </div>
                            <div className="col-sm-4 kierunekMies">
                                <div><i
                                    className="fa fa-exchange"> </i> {this.checkKierunek(item.kierunek)}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4 trasaMies">
                                Trasa: <span>{item.nazTr}</span>
                            </div>
                            <div className="col-sm-4 typMies">
                                Typ: <span>{item.nazZniz}</span>
                            </div>
                            <div className="col-sm-4 typMies">
                                Cena: <span>{this.checkCena(item)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            {!this.state.loading ?
                <div>
                    {this.state.doladuj ?
                        <div>
                            <div className="row">
                                <div className="col-sm-3" style={{paddingTop: 10}}><b>Doładuj kartę:</b></div>
                                <div className="col-sm-9 miesieczneButton">
                                    <Button bsStyle={'warning'} style={{color: 'white'}}
                                            onClick={() => this.setState({doladuj: false})}>Pokaż historię
                                        karty</Button>
                                </div>
                            </div>
                            <DoladowanieKarty idKa={this.props.item.idKa} item={this.props.item}/>
                        </div> :
                        <div>
                            <div className="row">
                                <div className="col-sm-3" style={{paddingTop: 10}}><b>Historia karty:</b></div>
                                <div className="col-sm-9 miesieczneButton">
                                    {this.props.item.status === 'ZWROCONA' || !this.props.item.esprzedaz ?

                                        <span>
                                            {!this.props.item.esprzedaz ? <span style={{fontSize: '0.75rem', color: '#1e90ff'}}>Brak możliwości doładowania karty ze zniżką specjalną</span> : null }
                                            {this.props.item.status === 'ZWROCONA' ? <span style={{fontSize: '0.75rem', color: 'red'}}>Brak możliwości doładowania zwróconej karty</span> : null }
                                        </span>

                                        : <Button bsStyle={'info'}
                                                                                            onClick={() => this.setState({doladuj: true})}>Opłać
                                        kolejny
                                        miesiąc</Button>}
                                </div>
                            </div>
                            <HistoriaKarty data={this.state.data}/>
                        </div>}
                </div> :
                <div style={{paddingTop: 25, textAlign: 'center', color: '#58b13d'}}>
                    <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                </div>
            }
        </div>

    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/PokazSzczegolyKarty.js